import React from "react";
import styled from "styled-components";

const EleInput = styled.input`
  appearance: none;
  position: relative;
  outline: 0;
  margin: 0;
  list-style: none;
  background: transparent;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border: none;
`;

export default React.forwardRef(function Input(props, ref) {
  const {
    textarea,
    value,
    onInput,
    onCompositionstart,
    onCompositionend,
    ...rest
  } = props;

  const [stateInputLock, setStateInputLock] = React.useState(false);

  const emitInput = (e) => {
    onInput && onInput(e.target.value);
  };

  const handleInput = (e) => {
    if (stateInputLock) return;
    emitInput(e);
  };
  const handleCompositionStart = (e) => {
    setStateInputLock(true);
    console.log("handleCompositionStart", e);
  };
  const handleCompositionEnd = (e) => {
    console.log("handleCompositionEnd", e);
    setStateInputLock(false);

    emitInput(e);
  };

  return (
    <EleInput
      as={textarea ? "textarea" : "input"}
      ref={ref}
      value={value}
      onInput={handleInput}
      // onCompositionStart={handleCompositionStart}
      // onCompositionEnd={handleCompositionEnd}
      {...rest}
    />
  );
});
